import React, { useState } from "react";
import {
  Input as BootstrapInput,
  InputGroup,
  Label,
  Fade,
  FormFeedback
} from "reactstrap";
import PropTypes from "prop-types";

import SVG from "../SVG";
import Button from "./Button";
import Error from "./Error";

const defaultType = "password";
const visibleType = "text";

export default function Password(props) {
  const [type, handleTypeChange] = useState(defaultType);
  const [showLabel, handleLabelAppearance] = useState(!!props.value);
  const {
    label = "",
    containerClass = "",
    labelClass = "",
    inputClass = "",
    handleChange,
    invalid,
    fieldError,
    ...inputProps
  } = props;
  const onChange = ({ target: { name, value } }) => {
    handleLabelAppearance(!!value);
    handleChange(name, value);
  };
  const handleClick = () =>
    handleTypeChange(type === defaultType ? visibleType : defaultType);

  return (
    <Label className={`input-container password ${containerClass}`}>
      <InputGroup>
        <Fade in={!!invalid} tag="span" className="invalid-dot" />
        <BootstrapInput
          type={type}
          className={`${inputClass}`}
          invalid={invalid}
          {...inputProps}
          onChange={onChange}
        />
        <Button
          onClick={handleClick}
          className={`password-glass ${
            type === defaultType ? defaultType : visibleType
          }`}
        >
          <SVG.Eye />
        </Button>
        <Error component={FormFeedback} error={fieldError} />
        <Fade
          in={!!showLabel}
          tag="span"
          className={`input-label ${labelClass}`}
        >
          {label}
        </Fade>
      </InputGroup>
    </Label>
  );
}

Password.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number])
    .isRequired,
  handleChange: PropTypes.func.isRequired,
  containerClass: PropTypes.string,
  labelClass: PropTypes.string,
  inputClass: PropTypes.string,
  fieldError: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.shape({})
  ]),
  invalid: PropTypes.bool
};

Password.defaultProps = {
  containerClass: "",
  labelClass: "",
  inputClass: "",
  fieldError: "",
  invalid: false
};
